/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetChallengeChallengeIdV2200Response
 */
export interface GetChallengeChallengeIdV2200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeIdV2200Response interface.
 */
export function instanceOfGetChallengeChallengeIdV2200Response(value: object): value is GetChallengeChallengeIdV2200Response {
    return true;
}

export function GetChallengeChallengeIdV2200ResponseFromJSON(json: any): GetChallengeChallengeIdV2200Response {
    return GetChallengeChallengeIdV2200ResponseFromJSONTyped(json, false);
}

export function GetChallengeChallengeIdV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeIdV2200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function GetChallengeChallengeIdV2200ResponseToJSON(json: any): GetChallengeChallengeIdV2200Response {
    return GetChallengeChallengeIdV2200ResponseToJSONTyped(json, false);
}

export function GetChallengeChallengeIdV2200ResponseToJSONTyped(value?: GetChallengeChallengeIdV2200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': value['result'],
    };
}

